/**
 * Created by Oleg on 08.08.2019.
 */

const BlanketCellView = BaseCellView.extend({
    ctor: function (blanketCell) {
        this._super();

        this.blanketCell = blanketCell;
        this.blanketCell.deleteView = this.deleteView.bind(this);

        const bigComponent = blanketCell.findComponent(BigComponent);

        if (!bigComponent.isHead) {
            return;
        }

        if (!blanketCell.isForGoal) {
            this.setAlignment(BaseCellView.alignInTheGrid(blanketCell.x + bigComponent.cols / 2 - 0.5, blanketCell.y + bigComponent.rows / 2 - 0.5));
            this.setContentSize(bigComponent.cols * cleverapps.styles.BaseCellView.CELL_SIZE_PX, bigComponent.rows * cleverapps.styles.BaseCellView.CELL_SIZE_PX);
        } else {
            const styles = this.getStyles();
            this.setContentSize2(styles.goal.width, styles.goal.height);
        }

        this.setAnchorPoint(0.5, 0.5);

        this.initialize(blanketCell);
    },

    getStyles: function () {
        return cleverapps.styles.BlanketCellView;
    },

    createEaterSpineContent: function (blanketCell) {
        const bigComponent = blanketCell.findComponent(BigComponent);

        const animationNode = new cc.Node();
        animationNode.setAnchorPoint(0, 0);
        this.allCells = [];
        for (let dy = 0; dy < bigComponent.rows; dy++) {
            const rowCells = [];
            for (let dx = 0; dx < bigComponent.cols; dx++) {
                const animation = new cleverapps.Spine(bundles.blanket.jsons.blanket_wrapper_spine1_json);
                animationNode.addChild(animation);
                animation.setAnimation(0, "idle", true);
                animation.setAlignment((dx + 0.5) * cleverapps.styles.BaseCellView.CELL_SIZE_PX, (dy + 0.5) * cleverapps.styles.BaseCellView.CELL_SIZE_PX);
                rowCells.push(animation);
            }
            this.allCells.push(rowCells);
        }
        this.addChild(animationNode);

        const baseX = (bigComponent.cols) * cleverapps.styles.BaseCellView.CELL_SIZE_PX / 2;
        const baseY = (bigComponent.rows) * cleverapps.styles.BaseCellView.CELL_SIZE_PX / 2;

        const elementNode = this.elementNode = new cc.Node();
        elementNode.setPosition(baseX, baseY);

        const tartlet = this.tartlet = new cc.Sprite(bundles.blanket.frames.tartlet_png);
        tartlet.setAnchorPoint(0.5, 0.5);
        elementNode.addChild(tartlet);
        tartlet.setScale(this.getStyles().centerImageTartlet.scale);

        const colors = blanketCell.getAcceptedColors();
        if (!colors || (colors && colors.length <= 0)) {
            return;
        }
        const item = this.item = new cc.Sprite(bundles.color_cells.frames[`color_cells_${colors[0]}`]);
        item.setAnchorPoint(0.5, 0.5);
        elementNode.addChild(item);
        item.setPosition(0, this.getStyles().centerImageElement.dy);
        item.setScale(this.getStyles().centerImageElement.scale);

        const tartlet2 = this.tartlet2 = new cc.Sprite(bundles.blanket.frames.tartlet2_png);
        tartlet2.setAnchorPoint(0.5, 0.5);
        elementNode.addChild(tartlet2);
        tartlet2.setScale(this.getStyles().centerImageTartlet2.scale);

        this.addChild(elementNode);
    },

    hurtAnimation: function () {
        if (this.onHurtAnimating) {
            return;
        }
        this.onHurtAnimating = true;
        const DURATION = 0.05;
        this.elementNode.runAction(new cc.Sequence(
            (new cc.ScaleTo(DURATION, 1.2)).easing(cc.easeIn(1)),
            (new cc.ScaleTo(DURATION, 1)).easing(cc.easeIn(1)),
            new cc.CallFunc(() => {
                this.onHurtAnimating = false;
            })
        ));
        cleverapps.effects.fire("match3.blanket.stage_decrease");
    },

    deleteView: function () {
        const bigComponent = this.blanketCell.findComponent(BigComponent);
        for (let dy = 0; dy < bigComponent.rows; dy++) {
            for (let dx = 0; dx < bigComponent.cols; dx++) {
                this.allCells[dy][dx].replaceParentSamePlace(this.parent);
                this.allCells[dy][dx].setAnimation(0, "animation", false);
                this.allCells[dy][dx].setLocalZOrder(100);
            }
        }

        this.runAction(new cc.Sequence(
            new cc.DelayTime(this.blanketCell.explodeDuration()),
            new cc.RemoveSelf()
        ));
        cleverapps.effects.fire("match3.blanket.die");
    }
});

cleverapps.styles.BlanketCellView = cleverapps.overrideStyles(cleverapps.styles.EaterCellView, {
    width: 120,
    height: 120,

    idleAnimation: true,

    goal: {
        width: 120,
        height: 120,
        image: {
            scale: 0.8
        }
    },

    centerImageTartlet: {
        scale: 0.96
    },

    centerImageElement: {
        scale: 1.46,
        dy: 13
    },

    centerImageTartlet2: {
        scale: 0.96
    }
}, true);